<template>
  <Modal
    :title="$t('edit_vat_group')"
    modalId="edit-modal"
    @submit="updateVatGroup"
  >
    <form @submit.prevent="updateVatGroup">
      <div class="mb-3">
        <label class="form-label">{{ $t('vat_group_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="vat_group.vat_group_name"
          class="form-control"
        />
        <!-- Error for vat group -->
        <div v-if="errors.vat_group_name" class="text-danger mt-2">
          <span>{{ errors.vat_group_name }}</span>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">{{ $t('vat_value') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="vat_group.vat_value"
          class="form-control"
        />
        <!-- Error for vat group -->
        <div v-if="errors.vat_value" class="text-danger mt-2">
          <span>{{ errors.vat_value }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedVatGroup: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      vat_group: {
        id: null,
        vat_group_name: '',
        vat_value: '',
      },
      errorMessage: '',
      errors: {},
    };
  },

  watch: {
    selectedVatGroup: {
      immediate: true,
      handler(newGroup) {
        if (newGroup && newGroup.id) {
          this.vat_group = { ...newGroup };
        }
      },
    },
  },
  methods: {
    async updateVatGroup() {
      try {
        const response = await this.$axios.patch(
          apiUrls.vat_group.update.replace(':pk', this.vat_group.id),
          { vat_group_name: this.vat_group.vat_group_name,
                vat_value: this.vat_group.vat_value,
              }
        );

        this.toast.success('Vat group successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'size' field is in errors and assign full error message
            if (error.response.data.vat_group && error.response.data.vat_group.length > 0) {
              // Assign the full error message from the array
              this.errors.vat_group = error.response.data.vat_group[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.vat_group = { id: null, vat_group_name: '', vat_value: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>